import { isValidImei } from "shared";

const useDataValidation = () => {
    const isValidSerial = (serial: string) => {
        const length = serial.length;
        return length === 0 || length === 10;
    };

    return { isValidImei, isValidSerial };
};

export { useDataValidation };
